import { Customer } from '../../store/Customer';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getCustomer = (id: string) => {
  return apiService.callExternalApi<Customer>({
    url: `${API_SERVER_URL}/account/customers/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const getCustomerSuppliers = (id: string) => {
  return apiService.callExternalApi<{ id: string; name: string }[]>({
    url: `${API_SERVER_URL}/account/customers/${id}/suppliers`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listCustomers = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters
  };

  return apiService.callExternalApi<PaginatedResponse<Customer>>({
    url: buildAdvancedQueryURL(mergedFilters, 'account/customers'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
